import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { changeFormFieldValue, setNewForm } from 'apps/auth/actions/formAction';
import { updateHeaderGrayTitle } from 'apps/auth/actions/messageAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import Form from 'apps/auth/components/form-multi/Form';
import { clearLeadingSpace, getSortFields } from 'apps/auth/components/form-multi/utils';
import AgreePopup from 'apps/auth/components/sharedComponents/popups/AgreePopup';
import { OFAKIM_GENDER_VERIFICATION_CONTINUE_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { XSS_FILTER_OPTIONS } from 'apps/auth/constants/Constants';
import { PROFILE_FORM_NAME } from 'apps/auth/constants/formName';
import { ISRAEL, USA } from 'apps/auth/constants/WellKnownCountries';
import { useAuth, useExtra, useFields, usePageMessages } from 'apps/auth/hooks/selectors';
import { UsaService } from 'apps/auth/services/UsaService';
import { filterXSS } from 'xss';

import TermsAgreePopup from './TermsAgreePopup';

const ProfileFieldsEdit = (props) => {
    const { buttonContinue, termsDisclaimerText, headerTitle, headerGrayTitle, readAndAgreeOurTC, popupTextUsaTerms, popupTextUsaElectronic, popupAgree } =
        usePageMessages();
    const { countryId } = useAuth();
    const { profileTermAccept, country_id, profile_form: profileForm, phoneCountry } = useExtra();
    const fields = useFields(PROFILE_FORM_NAME);
    const [termAccept, toggleTermAccept] = useState(profileTermAccept);
    const submitRef = useRef(null);
    const agreeCounter = useRef(1);

    useEffect(() => {
        toggleTermAccept(profileTermAccept);
        return () => {
            props.updateHeaderGrayTitle('');
        };
    }, [profileTermAccept]);

    const beforeSubmit = () => clearLeadingSpace(fields, PROFILE_FORM_NAME, props.changeFormFieldValue);

    const usaAgreeClick = (e) => {
        agreeCounter.current += 1;
        termsAgreeClick(e, agreeCounter.current);
    };

    const termsAgreeClick = (e, agreeCounterClick) => {
        e.preventDefault();
        if (USA === countryId && UsaService.isNewLimits(profileForm)) {
            if (agreeCounterClick === 1 || agreeCounterClick === 2) {
                props.popupRef.current?.open(
                    <AgreePopup
                        agreeHandler={usaAgreeClick}
                        text={agreeCounterClick === 1 ? popupTextUsaElectronic : popupTextUsaTerms}
                        popupRef={props.popupRef}
                        agreeButton={popupAgree}
                    />,
                );
            } else {
                props.popupRef.current?.close();
                submitRef.current.click();
            }
        } else {
            props.popupRef.current?.open(<TermsAgreePopup submitRef={submitRef} popupRef={props.popupRef} />);
        }
    };

    if (termAccept) {
        return (
            <>
                <HeaderPanel title={readAndAgreeOurTC} />
                <div className="maincopy break_words" dangerouslySetInnerHTML={{ __html: filterXSS(termsDisclaimerText, XSS_FILTER_OPTIONS) }} />
                <Form id="profile_form_id" formName={PROFILE_FORM_NAME} getCanonicalPath={true} validateForm={false} autoComplete="off">
                    <FixedBottomPanel isRightAligned>
                        <Button type="button" raised={true} onClick={(e) => termsAgreeClick(e, agreeCounter.current)} caption={buttonContinue} />
                    </FixedBottomPanel>
                    <input type="submit" ref={submitRef} className="hidden" />
                </Form>
            </>
        );
    } else {
        return (
            <>
                <HeaderPanel title={headerTitle} subtitle={headerGrayTitle} />
                {profileForm && (
                    <Form
                        id="profile_form_id"
                        formName={PROFILE_FORM_NAME}
                        getCanonicalPath={true}
                        beforeSubmit={beforeSubmit}
                        onSubmitHandler={(_fields, json) => {
                            const form = json?.forms[PROFILE_FORM_NAME];
                            if (form) {
                                props.setNewForm(PROFILE_FORM_NAME, form.fields, form.action);
                            }
                        }}
                    >
                        {profileForm.editable && (
                            <>
                                {getSortFields(fields).map((field) => {
                                    if (field.name !== 'redirect') {
                                        return (
                                            <Row indent="adaptive-32-48" key={field.name}>
                                                <InputAutoDetect
                                                    formName={PROFILE_FORM_NAME}
                                                    field={field}
                                                    defaultCountry={phoneCountry?.code}
                                                    country={phoneCountry}
                                                />
                                            </Row>
                                        );
                                    }
                                })}
                                <FixedBottomPanel isRightAligned>
                                    <Button
                                        type="submit"
                                        raised={true}
                                        caption={buttonContinue}
                                        title={buttonContinue}
                                        onClick={() => {
                                            country_id === ISRAEL ? amplitude.getInstance().logEvent(OFAKIM_GENDER_VERIFICATION_CONTINUE_CLICKED) : null;
                                        }}
                                    />
                                </FixedBottomPanel>
                            </>
                        )}
                    </Form>
                )}
            </>
        );
    }
};
export default connect(null, { setNewForm, updateHeaderGrayTitle, changeFormFieldValue })(ProfileFieldsEdit);
